import { TranslationObject } from '../i18n/translation';

const namespace = 'invitePsaUser';

const translations: TranslationObject = {
  titlePsa: {
    id: `${namespace}.titlePsa`,
    nb: 'Inviter en ny bruker',
    en: 'Invite new user',
  },
  titleUha: {
    id: `${namespace}.titleUha`,
    nb: 'Inviter en ny praksisstedbruker',
    en: 'Invite a new practice place user',
  },
  subtitlePsa: {
    id: `${namespace}.subtitlePsa`,
    nb: 'Fyll ut skjemaet under for å invitere en kollega til å bruke Arbeidslivsportalen',
    en: 'Fill out the form underneath to invite a colleague to use Arbeidslivsportalen',
  },
  subtitleUha: {
    id: `${namespace}.subtitleUha`,
    nb: 'Fyll ut skjemaet under for å invitere praksisstedsadministrator',
    en: 'Fill out the form underneath to invite a practice place administrator',
  },
  save: {
    id: `${namespace}.save`,
    nb: 'Inviter bruker',
    en: 'Invite user',
  },
  cancel: {
    id: `${namespace}.cancel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  success: {
    id: `${namespace}.success`,
    nb: 'Ny bruker opprettet - en melding med invitasjon har blitt sendt til {email}',
    en: 'User created - a message with an invitation has been sent to {email}',
  },
  error: {
    id: `${namespace}.error`,
    nb: 'Det skjedde en feil ved oppretting av ny bruker',
    en: 'We experienced an error',
  },
  usertitle: {
    id: `${namespace}.usertitle`,
    nb: 'Brukerinformasjon',
    en: 'User information',
  },
  usersubtitlePsa: {
    id: `${namespace}.usersubtitlePsa`,
    nb: 'Opplysninger om kollegaen som skal inviteres. Eposten vil bli brukt til å invitere brukeren.',
    en: 'Information about the colleague to be invited. The email will be used to notify the user.',
  },
  usersubtitleUha: {
    id: `${namespace}.usersubtitleUha`,
    nb: 'Opplysninger om brukeren som skal inviteres. Eposten vil bli brukt til å invitere brukeren.',
    en: 'Information about the user to be invited. The email will be used to notify the user.',
  },
  usergivenname: {
    id: `${namespace}.usergivenname`,
    nb: 'Fornavn',
    en: 'Given name',
  },
  usersurname: {
    id: `${namespace}.usersurname`,
    nb: 'Etternavn',
    en: 'Surname',
  },
  useremail: {
    id: `${namespace}.useremail`,
    nb: 'Epost',
    en: 'Email',
  },
  invitewithfnr: {
    id: `${namespace}.invitewithfnr`,
    nb: 'Inviter med fødselsnummer',
    en: 'Invite with national identity number',
  },
  userfnr: {
    id: `${namespace}.userfnr`,
    nb: 'Fødselsnummer',
    en: 'National identity number',
  },
  accesstitle: {
    id: `${namespace}.accesstitle`,
    nb: 'Tilganger',
    en: 'Access',
  },
  accesssubtitle: {
    id: `${namespace}.accesssubtitle`,
    nb: 'Velg rolle og tilgangsnivå for brukeren',
    en: 'Select the role and access to grant the user',
  },
  accessplace: {
    id: `${namespace}.accessplace`,
    nb: 'Tilgangsnivå',
    en: 'Access level',
  },
  accessplaceholder: {
    id: `${namespace}.accessplaceholder`,
    nb: 'Velg ønsket tilgangsnivå for brukeren',
    en: 'Specify an access level for the user',
  },
  rolePermission: {
    id: `${namespace}.accesspermission`,
    nb: 'Rettighet',
    en: 'Permission',
  },
  rolleAdministrator: {
    id: `${namespace}.rolleAdministrator`,
    nb: 'Administrator',
    en: 'Administrator',
  },
  rolleSkriverettighet: {
    id: `${namespace}.rolleSkriverettighet`,
    nb: 'Skriverettighet',
    en: 'Write access',
  },
  rolleLeserettighet: {
    id: `${namespace}.rolleLeserettighet`,
    nb: 'Leserettighet',
    en: 'Read access',
  },
  invalidEmail: {
    id: `${namespace}.invalidEmail`,
    nb: 'Epostadressen har ugyldig format. Dette skjer f.eks om adressen inneholder Æ-Ø-Å.',
    en: 'The email address is invalid. This may happen e.g. when it contains Æ-Ø-Å',
  },
  roleChoose: {
    id: `${namespace}.roleChoose`,
    nb: 'Velg rettighetsnivå',
    en: 'Choose permission degree',
  },
};

export default translations;
